import * as React from "react";
import {CSSProperties} from "react";
import {StoreControl, StoreControlProps, StoreControlState} from "../base/StoreControl";
import {observer} from "mobx-react";
import {ValidatorBase} from "../../utilities/validator/ValidatorBase";
import {StoreBase} from "../../utilities/Store/StoreBase";
import {PropertyValidator} from "../../utilities/validator/PropertyValidator";

@observer
export class RNTextInput<S extends StoreBase> extends StoreControl<RNTextInputProps<S>, RNTextInputState> {
    static defaultProps: Partial<RNTextInputProps<any>> = {};

    constructor(props: RNTextInputProps<S>) {
        super(props);
        this.state={
            IsValid:true,
            ErrorMessage:''
        }
    }

    public render() {
        return (
            <div className={'rncontrol'} style={this.props.style}>
                <div>
                    {   this.props.Label!=''&&
                        <label style={{width: '100%', display: 'block'}}>{this.props.Label}</label>
                    }
                    <input placeholder={this.props.placeholder} type={this.props.type} disabled={this.props.disabled} className={'rnform-control'} value={this.props.type=='numeric'?this.GetNumericValue():this.GetStringValue()} onChange={(e)=>{this.SetValue(e.target.value)}}/>
                    {this.GetValidationSection()}
                </div>
            </div>
        )
    }

    GetValidators(): ValidatorBase[] {
        return [
            new PropertyValidator(this.props,"Required",()=>{return this.GetStringValue()!=''},"Required field")
        ];
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface RNTextInputProps<S extends StoreBase> extends StoreControlProps<S>{
    style?:CSSProperties;
    Label:string;
    onChange?:(value:string)=>void;
    disabled?:boolean;
    type?:string;
    placeholder?:string;
}

interface RNTextInputState extends StoreControlState{

}

//#endregion "My Region"